import React from 'react';

import {SurveyFormInputEnhance} from "./SurveyFormInputEnhance";
import {SurveyFormInputFileEnhance} from "./SurveyFormInputFileEnhance";
import {FileVisibilityHelper} from "../../Files/FileVisibilityHelper";

@SurveyFormInputEnhance
@SurveyFormInputFileEnhance
export class SurveyFormInputFileViewer extends React.Component {
    render() {
        let answer = this.props.Answer;
        const SurveyFormInputFile = this.props.SurveyFormInputFile;

        if(answer && answer.fileUploadId) {
            return <span>
                <a className="link-primary" onClick={() => SurveyFormInputFile.DownloadFile(answer.fileUploadId)}>
                    {
                        SurveyFormInputFile.FileUpload ?
                            SurveyFormInputFile.FileUpload.name:
                            "N/A"
                    }
                </a>
                <FileVisibilityHelper file={SurveyFormInputFile?.FileUpload} />
            </span>;
        }

        return null;
    }
}


